import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeleteWithTypeDialogComponent } from '@libs/shared/ui/dialogs/delete-with-type-dialog/delete-with-type-dialog.component';
import { DeleteWithTypeDialogConfig } from '@libs/shared/ui/dialogs/delete-with-type-dialog/delete-with-type-dialog.type';

@Injectable()
export class DeleteWithTypeDialogService {
  readonly matDialog = inject(MatDialog);

  // prettier-ignore
  open(config: DeleteWithTypeDialogConfig): MatDialogRef<DeleteWithTypeDialogComponent, boolean> {
    const defaultConfig = {
      submitText: "삭제하기",
    };

    return this.matDialog.open(DeleteWithTypeDialogComponent, {
      autoFocus: true,
      disableClose: true,
      maxWidth: "600px",
      data: { ...defaultConfig, ...config },
    });
  }
}
